import { render } from "./SimpleSelect.vue?vue&type=template&id=4225e878"
import script from "./SimpleSelect.vue?vue&type=script&lang=js"
export * from "./SimpleSelect.vue?vue&type=script&lang=js"

import "./SimpleSelect.vue?vue&type=style&index=0&id=4225e878&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__